<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { Link } from '$global/components/Link';

	interface Props {
		href: string;
		dataCy: string;
		showNewVersion: boolean;
		children?: import('svelte').Snippet;
		class?: string;
		onclick?: () => void;
	}

	let { ...props }: Props = $props();

	let dataCyPrefix = $derived(`${props.dataCy}-card-tag`);
</script>

<Link
	onclick={props.onclick}
	href={props.href}
	class={twMerge(
		classNames(
			'relative flex items-center rounded-full border px-2 py-1 whitespace-nowrap',
			{ '!px-0 !py-0': props.showNewVersion }
		),
		props.class
	)}
	data-cy={dataCyPrefix}
>
	{@render props.children?.()}
</Link>
